//----------------------------------------
// ScanSDK カメラ制御（scandit以外）
//----------------------------------------
// scandit は sdk.enableCamera(true/false) でカメラを開閉している。
// barkoder / scanbot も同じタイミング・同じ挙動になるよう、
// 選択中のSDKに応じてカメラの起動・停止を振り分ける。
//
//   ・スタート画面        → 起動（App.js）
//   ・スキャンボタン押下  → 起動（Shopping.jsx）
//   ・お会計ボタン押下    → 起動（Shopping.jsx）
//   ・スキャン画面から離脱 → 停止（各スキャン画面の releaseScreen）
//
// カメラ描画先は body 直下の常駐コンテナ（scanHost.js）に置いてあるため、
// スキャン画面が未表示でもカメラを起動しておける。

import { startCamera as startBarkoderCamera, releaseCamera as releaseBarkoderCamera } from "./barkoderSdk";
import { startCamera as startScanbotCamera, releaseCamera as releaseScanbotCamera } from "./scanbotSdk";
import { SCAN_SDK_BARKODER, SCAN_SDK_SCANBOT } from "./scanSdkSetting";

//----------------------------------------
//カメラ起動（SDK本体・wasmの読み込みも含む
//----------------------------------------

export async function startScanSdkCamera(scanSdk) {
	try {
		if (scanSdk === SCAN_SDK_BARKODER) {
			console.log("【ScanSDK】barkoder camera start");
			await startBarkoderCamera();
			return;
		}

		if (scanSdk === SCAN_SDK_SCANBOT) {
			console.log("【ScanSDK】scanbot camera start");
			await startScanbotCamera();
			return;
		}
	} catch (e) {
		//失敗した場合はスキャン画面側で再試行されるためログのみ
		console.log("【ScanSDK】camera start error: " + e);
	}
}

//----------------------------------------
//カメラ停止
//----------------------------------------

export async function releaseScanSdkCamera(scanSdk) {
	try {
		if (scanSdk === SCAN_SDK_BARKODER) {
			await releaseBarkoderCamera();
			return;
		}

		if (scanSdk === SCAN_SDK_SCANBOT) {
			await releaseScanbotCamera();
			return;
		}
	} catch (e) {
		console.log("【ScanSDK】camera release error: " + e);
	}
}
